import _ from 'lodash'
import { getSnapshot } from 'mobx-state-tree'
import { useEffect, useMemo, useState } from 'react'
import { ModelUpdateInfo } from './FlowController'

export function useEditorModel<T = any>(
  document: any,
  group: string,
  identifier: string,
  onValueUpdate: (updateInfo: ModelUpdateInfo) => void,
  defaultContent: T | null = null,
  validator?: (value: T | null) => boolean,
  Model?: any,
) {
  const initialContent = useMemo(() => {
    try {
      const item = document?.data.get(group)?.get(identifier, true)
      const content = getSnapshot<any>(item).content
      if (Model) {
        return content ? Model.create(item.content) : Model.create({})
      }
      return item ? content ?? defaultContent : defaultContent
    } catch {
      return defaultContent
    }
  }, [document, group, identifier, defaultContent, Model])

  const [value, setValue] = useState<T>(() => initialContent)

  useEffect(() => {
    const valueToSet =
      _.isObject(value) && !_.isArray(value) ? getSnapshot(value) : value

    if (onValueUpdate) {
      onValueUpdate({
        value: valueToSet,
        filled: validator ? validator(value) : !!value,
        group: group,
        identifier: identifier,
      })
    }
  }, [validator, value, onValueUpdate, group, identifier])

  return useMemo(
    () => ({
      value,
      setValue(name, _value) {
        setValue(_value)
      },
    }),
    [value, setValue],
  )
}
